module.exports = __webpack_public_path__ + "media/images/dashboard/light/tile_icon_top_campaigns-792d283bd0617afa41d325408d832b17.png";